import React, { useEffect, useState } from "react";
import Header from "../../components/template/estimate/Header";
// import MoveInfo from "../../components/summary/MoveInfo";
import InventoryList from "../../components/summary/InventoryList";
import ProgressBar from "../../components/storage_service/ProgressBar";
import { useSelector, useDispatch } from "react-redux";
import { thunkLoadMoveInfoFromSession } from "../../redux/reducers/storage_moveinfo/moveInfoReducer";
import { loadFromSession } from "../../redux/reducers/inventory/inventoryReducer";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {
  getBoxesCount,
  getTotalItemsCount,
} from "../../pages/inventory/Inventory";
import Moment from "moment";
import {
  ErrorMessage,
  SubmitProgress,
} from "../../components/inventory/Modal/LoginModal";
import navigationLinks from "../../constants/navigation_links";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { updateOrderData } from "../../adapters/estimate/estimateAdapters";
import navigationsLinks from "../../constants/navigation_links";
import { getClientTimezone } from "../../adapters/estimate/estimateAdapters";
import { thunkClearEstimateData } from "../../redux/reducers/storage_progress/progressReducer";
import momentTimeZone from "moment-timezone";
import { verifyOrderInDB } from "../../functions/helper";
import { getAreaCount, getVolumeCount } from "../../components/inventory/InventoryHelper";
export function StorageSummary() {
  const dispatch = useDispatch();
  const history = useHistory();
  const moveInfo = useSelector((state) => state.storageMoveInfo);
  const propertyInfo = useSelector((state) => state.propertyInfo);
  const inventoryInfo = useSelector((state) => state.inventoryInfo);
  const [additionalData, setAdditionalData] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [transportType, setTransportType] = useState("BX-STG-Pickup");
  const [error, setError] = useState(false);
  const [submitProgress, setSubmitProgress] = useState(false);
  const [progressModal, setProgressModal] = useState(false);
  const inventory = useSelector((state) => state.inventoryInfo);
  const moveInfoData = {};

  const moveDate = Moment(new Date(moveInfo.pickupDate));
  moveInfoData["date"] = moveDate.format("DD"); //Ex: 01 02 ... 30 31
  moveInfoData["month"] = moveDate.format("MMM"); //Ex: Jan,Feb..
  moveInfoData["year"] = moveDate.format("YYYY"); // Ex:2020.2019..
  moveInfoData["totalItems"] = getTotalItemsCount(inventory);

  const totalItemsCount = parseInt(getTotalItemsCount(inventory));
  const boxesCount = parseInt(getBoxesCount(inventory));
  useEffect(() => {
    if (
      moveInfo.hasLoadedFromSession === false &&
      sessionStorage.getItem("storage_moveinfo") !== null
    ) {
      const moveInfo = sessionStorage.getItem("storage_moveinfo");
      dispatch(thunkLoadMoveInfoFromSession({ moveInfo: moveInfo }));
    }
    // if (
    //   propertyInfo.hasLoadedFromSession === false &&
    //   sessionStorage.getItem("property_info") !== null
    // ) {
    //   const propertyInfo = sessionStorage.getItem("property_info");
    //   dispatch(
    //     thunkLoadPropertyInfoFromSession({ propertyInfo: propertyInfo })
    //   );
    // }
    if (
      inventoryInfo.get("inventory").size === 0 &&
      sessionStorage.getItem("storage_inventory_info") !== null
    ) {
      const inventoryInfo = JSON.parse(
        sessionStorage.getItem("storage_inventory_info")
      );
      dispatch(loadFromSession(inventoryInfo));
    }
    // if (sessionStorage.getItem("summaryInfo") !== null) {
    //   const summaryInfo = JSON.parse(sessionStorage.getItem("summaryInfo"));
    //   setAdditionalData(summaryInfo.additionalInfo);
    // }
  }, [
    dispatch,
    inventoryInfo,
    propertyInfo.hasLoadedFromSession,
    moveInfo.hasLoadedFromSession,
  ]);
  const handleEstimateSubmit = async (e) => {
    setProgressModal(true);
    setSubmitProgress(true);
    const isOrderOutdated = await verifyOrderInDB("storage");
    if (isOrderOutdated === true) {
      dispatch(thunkClearEstimateData());
      history.push("/storage-services/get-quote");
      return;
    }
    const userSessionData = JSON.parse(
      sessionStorage.getItem("userSessionData")
    );
    const orderDetails = JSON.parse(
      sessionStorage.getItem("storageOrderDetails")
    );
    const estimate_id = orderDetails.orderId;
    const userId = userSessionData.userId;
    const additionalInfo = additionalData;
    const params = {
      additional_info: additionalInfo,
      user_id: userId,
      estimate_id: estimate_id,
      update_type: "storage_order_submit",
      lead_stage: "payment_initiated",
      transport_type: transportType,
    };
    if (transportType === "BX-STG-Pickup") {
      const moveInfo = JSON.parse(sessionStorage.getItem("storage_moveinfo"));
      const itemsJSON = JSON.stringify(inventory.toJS());
      const totalItemsCount = getTotalItemsCount(inventory);
      const totalVolume = getVolumeCount(inventory);
      const totalArea = getAreaCount(inventory);
      const customerName = userSessionData.customerName;
      const clientTimezone = getClientTimezone();

      let pickupDate = new Date(moveInfo.pickup_date);
      pickupDate = momentTimeZone
        .tz(pickupDate, "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
      const fromAddress = {
        firstName: customerName,
        lastName: "",
        fromAddress: moveInfo.pickup_address,
        fromLocality: "",
        fromCity: moveInfo.select_city,
        fromState: "",
        pincode: "",
      };
      const toAddress = {
        firstName: customerName,
        lastName: "",
        toAddress: "Boxigo Storage Service",
        toLocality: "Rampura",
        toCity: "Bengaluru",
        toState: "Karnataka",
        pincode: "562149",
      };
      params.user_id = userId;
      params.city_type = "within city";
      params.select_city = moveInfo.select_city;
      params.moving_from = moveInfo.pickup_address;
      params.moving_to = "";
      params.moving_on = pickupDate;
      params.distance = "15 Km";
      params.duration = "1 hrs";
      params.property_size = "FEW ITEMS";
      params.move_date_flexible = 1;
      params.old_floor_no = moveInfo.floor_no;
      params.new_floor_no = 0;
      params.old_elevator_availability = "No";
      params.packing_service = "Yes";
      params.new_elevator_availability = "No";
      params.unpacking_service = "No";
      params.old_parking_distance = 0;
      params.new_parking_distance = 0;
      params.old_house_additional_info = "";
      params.new_house_additional_info = "";
      params.items = itemsJSON;
      params.total_items = totalItemsCount;
      params.volume_cuft = totalVolume;
      params.area_sqft = totalArea;
      params.call_back = 0;
      params.service_type = "storage";
      params.client_timezone = clientTimezone;
      params.from_address = JSON.stringify(fromAddress);
      params.to_address = JSON.stringify(toAddress);
      params.created_by = "customer";
      params.lead_stage = "payment_initiated";
      params.is_create_relocation = "1";
      params.days_of_storage = moveInfo.days_of_storage;
      params.version = "v2";
      params.lead_source = "website";
    }
    try {
      const response = await updateOrderData(params);
      if (response.data.code === 200) {
        setSubmitProgress(false);
        setProgressModal(false);
        //clear storage data
        dispatch(thunkClearEstimateData({ history }));
        history.push(navigationsLinks.confirmation_page + "/storage/" + estimate_id);
      }
    } catch (e) {
      console.error(e);
      setSubmitProgress(false);
      setError({
        status: true,
        message: "OOP's! An Error Occurred, Please try again later.",
      });
    }
    return;
  };
  const saveAdditionalInfoToSession = (props) => {
    const gotoPage = props.gotoPage;
    const summaryInfo = { additionalInfo: additionalData };
    sessionStorage.setItem("summaryInfo", JSON.stringify(summaryInfo));
    history.push(gotoPage);
  };

  const JSX = (
    <React.Fragment>
      <Header
        currentPage="storage_summary"
        referenceToSubmit={saveAdditionalInfoToSession}
        serviceType="storage"
      />
      <main className="container">
        <div>
          <section class="progress-bar-section">
            <div class="row align-items-center justify-content-center">
              <div class="col-sm-12 col-md-12 col-lg-9">
                <ProgressBar
                  currentPage="storage_summary"
                  referenceToSubmit={saveAdditionalInfoToSession}
                />
              </div>
            </div>
          </section>
        </div>
        <div className="storage-summary-container summary-container">
          <section className="heading">
            <h3> Your move summary </h3>
          </section>
          <>
            <section className="move-info mb-4">
              <div>
                <div className="move-date-card">
                  <div className="month">{moveInfoData.month}</div>
                  <div className="date">{moveInfoData.date}</div>
                  <div className="year">{moveInfoData.year}</div>
                  <div className="banner-clip-right"></div>
                </div>
              </div>

              <div>
                <div className="address-info-container">
                  <div className="w-100">
                    <div className="mb-3">
                      <h3> From </h3>
                      <div>
                        <h4 className="property-info-title">House Details</h4>
                        <div className="value"> {moveInfo.pickupAddress} </div>
                      </div>
                    </div>
                    <div className="property-details d-flex flex-row justify-content-between">
                      {moveInfo.serviceLiftAvailable === "No" && (
                        <div>
                          <h4 className="property-info-title">Floor No</h4>
                          <div className="value">{moveInfo.floorNo}</div>
                        </div>
                      )}

                      <div>
                        <h4 className="property-info-title">
                          Elevator Available
                        </h4>
                        <div className="value">
                          {" "}
                          {moveInfo.serviceLiftAvailable}{" "}
                        </div>
                      </div>

                      <div>
                        <h4 className="property-info-title">Total Items </h4>
                        <div className="value">
                          {" "}
                          {totalItemsCount - boxesCount}
                        </div>
                      </div>
                      <div>
                        <h4 className="property-info-title">Boxes Required </h4>
                        <div className="value"> {boxesCount}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="transport-options">
              <label for="" class="form-label">
                <b>Transport Required</b>
              </label>
              <div className="d-flex mb-4">
                <div className="move-type">
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id="boxigo_transport"
                      onChange={(e) => {
                        setTransportType("BX-STG-Pickup");
                      }}
                      name="boxigo_transport"
                      value="BX-STG-Pickup"
                      checked={
                        transportType === "BX-STG-Pickup" ? true : false
                      }
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="boxigo_transport"
                    >
                      Boxigo Transport
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id="self_drop"
                      onChange={(e) => {
                        setTransportType("self_drop");
                      }}
                      name="self_drop"
                      value="self_drop"
                      checked={transportType === "self_drop" ? true : false}
                    />
                    <label className="custom-control-label" htmlFor="self_drop">
                      Self Drop
                    </label>
                  </div>
                </div>
              </div>
            </section>
            <section className="additonal">
              <div className="additional-data">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                    <div>
                      <label for="" class="form-label">
                        <b>Any Additional Information</b>
                      </label>

                      <textarea
                        name="additional_info"
                        id=""
                        value={additionalData}
                        cols="30"
                        rows="2"
                        onChange={(e) => {
                          const value = e.target.value;
                          setAdditionalData(value);
                          return;
                        }}
                        class="form-control"
                        placeholder="Ex. Dog at home | Please call when your reach |  Collect Security pass"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 summary-action-container">
                    <div className="d-flex justify-content-end align-items-center">
                      {/* <button className="btn btn-dark mx-2 px-4 btn-sm"></button> */}
                      <button
                        className="btn btn-dark mx-2 px-4 btn-sm text-capitalize text-nowrap"
                        onClick={() => {
                          history.push(navigationLinks.storage_inventory_page);
                          // props.editInventoryNavFn({
                          //   gotoPage: navigationLinks.inventory_page,
                          // });
                        }}
                      >
                        Edit Inventory
                      </button>
                      <div className="d-flex justify-content-center">
                        {/* auth LoginModal.jsx modal handles the estimate flow submit logic.   */}
                        <button
                          className="btn px-5 btn-sm"
                          onClick={() => {
                            handleEstimateSubmit();
                          }}
                        // onClick={() => props.authSubmit.setLoginModal(true)}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>

          <section className="items-info">
            <div className="mb-4 d-flex align-items-center justify-content-start">
              <h3 className="m-0"> Your Inventory List </h3>
              <button
                className="btn btn-sm ml-3 show-all-eye"
                onClick={() => {
                  setShowAll(!showAll);
                }}
              >
                {showAll === false && <FontAwesomeIcon icon={faEyeSlash} />}
                {showAll === true && <FontAwesomeIcon icon={faEye} />}
              </button>
            </div>
            <div className="accordian pb-5">
              <InventoryList showAll={showAll} />
            </div>
          </section>
        </div>
        <ProgressModal
          isOpen={progressModal}
          toggle={() => setProgressModal(false)}
          submitProgress={submitProgress}
          error={error}
        />
      </main>
    </React.Fragment>
  );
  return JSX;
}

function ProgressModal(props) {
  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.submitProgress === false ? props.toggle : () => { }}
      size={"md"}
      centered={true}
    >
      <ModalHeader
        toggle={props.submitProgress === false ? props.toggle : () => { }}
        className="border-0 pop-up-header"
      ></ModalHeader>
      <ModalBody className="modal-body login pop-up-login p-0">
        {/* Skip progress update */}
        {props.submitProgress === true && <SubmitProgress />}
        {/* {submitProgress === false && error.status === false && (
        
      )} */}
        {props.submitProgress === false && props.error.status === true && (
          <ErrorMessage
            error={props.error}
            updateError={(data) => {
              props.toggle();
            }}
          />
        )}
      </ModalBody>
    </Modal>
  );
}
